import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import { DateRangeInputWrapper, DateInputWrapper } from '../DateInputWrapper'
import { TimeInputWrapper } from '../TimeInputWrapper'
import { ReportRefreshButton } from '../ReportRefreshButton'

export default function ReportActions({
  isLoading,
  isRefreshing,
  onRefresh,
  showRefresh = true,
  downloadReport,
  downloadPDF,
  selected,
  fromDate,
  toDate,
  data,
  startDate,
  setStartDate,
  showTime = true,
  onDateRangeChange,
  getButton,
  children,
}) {
  const isDisabled = () => {
    if (selected) {
      // time stamp report
      if (startDate) return !selected && !startDate
      return false
    } else if (fromDate && toDate) return !fromDate && !toDate
    return true
  }

  return (
    <Stack direction="horizontal" gap={3} className="mb-4 align-items-end">
      {children}
      {onDateRangeChange && (
        <div style={{ width: '400px' }}>
          <DateRangeInputWrapper
            id="dateRange"
            startDate={fromDate}
            endDate={toDate}
            onChange={onDateRangeChange}
            isReadOnly={isLoading}
            size="sm"
            styles="form-control-height"
          />
        </div>
      )}
      {setStartDate && (
        <div className="d-flex gap-3">
          <DateInputWrapper
            id="report-start"
            startDate={startDate}
            selectedDate={startDate}
            setDate={setStartDate}
            showMinDate={false}
            isReadOnly={isLoading}
            size="sm"
            styles="form-control-height"
          />
          {showTime && (
            <TimeInputWrapper
              id="report-start-time"
              isReadOnly={isLoading}
              shouldFilterTimes={false}
              setDate={setStartDate}
              selectedDate={startDate}
              size="sm"
              styles="form-control-height"
            />
          )}
        </div>
      )}
      {getButton && getButton()}
      {showRefresh && onRefresh && (
        <ReportRefreshButton
          onRefresh={onRefresh}
          isRefreshing={isRefreshing ?? isLoading}
          disabled={isDisabled()}
          size="compact"
        />
      )}
      {downloadReport && (
        <Button
          variant="outline-light"
          className="icon-button btn-download form-control-height"
          disabled={isDisabled() || isLoading || !data || data?.length === 0}
          onClick={downloadReport}
        >
          Excel
        </Button>
      )}
      {downloadPDF && (
        <Button
          variant="outline-light"
          className="icon-button btn-download form-control-height"
          disabled={!selected || isLoading}
          onClick={downloadPDF}
        >
          PDF
        </Button>
      )}
    </Stack>
  )
}
